<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <validation-observer v-slot="{ invalid, handleSubmit }">
        <form
          @submit.prevent="handleSubmit(onSubmit)"
          class="tw-flex tw-flex-col tw-gap-4"
        >
          <div>
            <validation-provider
              name="service"
              rules="required"
              v-slot="{ dirty, invalid, errors }"
            >
              <label for="">Service</label>
              <v-select
                @search="searchServices"
                v-model="payload.service_id"
                :options="items"
                :reduce="(item) => item.id"
                label="name"
                :class="{
                  error: dirty && invalid,
                }"
                placeholder="Select Service"
              >
                <template slot="no-options"> Type to search.. </template>
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes"
                    ><i-icon
                      icon="radix-icons:caret-down"
                      color="#4F4F4F"
                      width="18px"
                  /></span>
                </template>
              </v-select>
              <span class="tw-text-xs tw-text-error" v-if="errors">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>

          <div>
            <validation-provider
              name="quantity"
              rules="required"
              v-slot="{ dirty, invalid, errors }"
            >
              <label for="">Quantity</label>

              <input
                type="text"
                id="input"
                placeholder="Enter Quantity"
                v-model="payload.quantity"
                :class="{
                  error: dirty && invalid,
                }"
              />
              <span class="tw-text-xs tw-text-error" v-if="errors">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>

          <span
            v-if="!viewMode"
            slot="footer"
            class="dialog-footer tw-flex tw-gap-2 tw-justify-center"
          >
            <button
              class="veo-btn veo-primary"
              :disabled="invalid"
              :class="{ 'tw-bg-gray-400': invalid || busy }"
            >
              {{ editMode ? "Edit" : "Create New" }}
            </button>
          </span>
        </form>
      </validation-observer>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: () => {},
    },
    code_type: {
      type: String,
      default: "referral_code",
    },
  },
  data() {
    return {
      dialogVisible: false,
      items: [],
      payload: {
        service_id: null,
        quantity: null,
        id: this.$route.params.id,
      },
      busy: false
    };
  },
  methods: {
    onSubmit() {
      let formData = new FormData();
      formData.append("service_id", this.payload.service_id);
      formData.append("quantity", this.payload.quantity);
      formData.append("plan_id", this.payload.id);
      this.busy = true;
      this.$inventory
        .addPlanBenefit(formData, formData)
        .then((res) => {
          console.log(res.data, "ommmo");
          this.$toastify({
            text: `Plan Benefit created successfully`,
            className: "info",
            style: {
              background: "#333",
              fontSize: "12px",
              borderRadius: "5px",
            },
          }).showToast();
          this.busy = false;
          this.$emit("isComplete");
        })
        .catch((err) => {
          console.log(err);
          this.busy = false;
        });
    },

    handleClose() {
      this.$emit("handleClose");
    },

    searchServices(search, loading) {
      let payload = { name: search };
      loading(true);
      this.$inventory
        .searchServices(payload)
        .then((res) => {
          console.log(res);
          this.items = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading(false);
        });
    },
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
      },
      immediate: true,
    },
  },
};
</script>

<style></style>
